import type { SxProps, Theme } from '@mui/material/styles';
import { APP_FONT_SIZE, APP_LINE_HEIGHT } from '../../constants/typography';

/** Standalone filter row above the table card (not inside the table Paper). */
export const trainingFilterBarSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1.5,
  flexWrap: 'wrap',
  alignItems: 'center',
  mb: 2,
};

/** Shared field styling for toolbar search + level filter */
export const trainingToolbarFilterFieldSx: SxProps<Theme> = {
  bgcolor: 'background.paper',
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
  },
  '& .MuiInputBase-input': {
    fontSize: APP_FONT_SIZE.sm,
    lineHeight: APP_LINE_HEIGHT.normal,
  },
  '& .MuiInputLabel-root': {
    fontSize: APP_FONT_SIZE.sm,
  },
};

export const trainingToolbarSearchFieldSx: SxProps<Theme> = {
  ...trainingToolbarFilterFieldSx,
  minWidth: 220,
  maxWidth: 360,
  flex: '1 1 220px',
};

export const trainingToolbarLevelSelectSx: SxProps<Theme> = {
  ...trainingToolbarFilterFieldSx,
  minWidth: 180,
  maxWidth: 220,
  flex: '0 0 180px',
};

export const trainingToolbarHintSx: SxProps<Theme> = {
  flex: '1 1 200px',
  minWidth: 160,
  maxWidth: 420,
  ml: { md: 'auto' },
  lineHeight: 1.45,
};

/**
 * Body cell sx for the training tables. The tables themselves use stock MUI
 * `Table` styling (from the content theme); only empty "—" cells are muted.
 */
export const trainingBodyCellSx = (
  isPlaceholder: boolean,
  extra?: SxProps<Theme>,
): SxProps<Theme> => [
  ...(Array.isArray(extra) ? extra : extra ? [extra] : []),
  isPlaceholder && { color: 'text.disabled' },
];
